import './application-detail-layout.scss';

import { LeftNavigation } from '../components';
import { NavigationItem } from '@converge/graphql';
import { NewLeftNavigation } from '../components/new-left-navigation';
import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';

interface IApplicationDetailLayoutProps {
  leftNavItems: NavigationItem[];
  selectedLeftNavItem: NavigationItem | null;
  onLeftNavItemSelected(item: NavigationItem): void;
  selectedSubLeftNavItem?: NavigationItem | null;
  onSubLeftNavItemSelected?(
    item: NavigationItem,
    parentItem: NavigationItem
  ): void;
  children: ReactNode;
  getItemIcon?: (icon: string) => React.ReactNode;
}

export const ApplicationDetailLayout = ({
  leftNavItems,
  selectedLeftNavItem,
  onLeftNavItemSelected,
  selectedSubLeftNavItem,
  onSubLeftNavItemSelected,
  children,
  getItemIcon,
}: IApplicationDetailLayoutProps) => {
  const { pathname } = useLocation();

  const isClaimsSection = pathname.startsWith('/claims');
  const isInsuredSection = pathname.startsWith('/insureds');
  // Determine the route type for styling purposes
  const getRouteType = () => {
    if (isClaimsSection) return 'claims';
    if (isInsuredSection) return 'insureds';
    return 'default';
  };

  return (
    <Stack
      className="application-detail-container"
      flexDirection={'row'}
      overflow={'hidden'}
      flexGrow={1}
      data-route={getRouteType()}
    >
      <Stack component={'aside'} className="leftNavigation-container">
        {isClaimsSection || isInsuredSection ? (
          <NewLeftNavigation
            items={leftNavItems}
            selectedItem={selectedLeftNavItem}
            onItemSelected={onLeftNavItemSelected}
            selectedSubItem={selectedSubLeftNavItem}
            onSubItemSelected={onSubLeftNavItemSelected}
            getItemIcon={getItemIcon}
          />
        ) : (
          <LeftNavigation
            items={leftNavItems}
            selectedItem={selectedLeftNavItem}
            onItemSelected={onLeftNavItemSelected}
            selectedSubItem={selectedSubLeftNavItem}
            onSubItemSelected={onSubLeftNavItemSelected}
          />
        )}
      </Stack>
      <Stack component={'main'} className="main-content" overflow={'auto'}>
        {children}
      </Stack>
    </Stack>
  );
};
